import {
  AppBar,
  Box,
  Button,
  IconButton,
  Toolbar,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import {selectForecastMapsEnabled} from '@smartmixin/core';
import {messages} from '@smartmixin/i18n';
import {useIntl} from 'react-intl';
import {useSelector} from 'react-redux';
import Logo from '../../components/Logo';
import Stack from '../../components/Stack';
import ForecastMapsMenu from './ForecastMapsMenu';
import ThemeToggle from './ThemeToggle';
import UserMenu from './UserMenu';

const AppNavBar = () => {
  const {formatMessage} = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  // Flag-gated (forecast_maps, fail-closed): hidden until the backend enables
  // the flag for this user.
  const forecastMapsEnabled = useSelector(selectForecastMapsEnabled);
  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        backgroundColor: (theme) => theme.palette.background.paper,
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}>
      <Toolbar>
        {/* Logo and brand - always show on mobile, hide text on very small screens */}
        <Stack
          direction="row"
          spacing={1}
          sx={{display: 'flex', alignItems: 'center'}}>
          <IconButton href="/" size="small" sx={{p: 0.5}}>
            <Logo size={26} />
          </IconButton>
          {!isMobile && (
            <Box
              component="span"
              sx={{
                fontWeight: 600,
                fontSize: '1rem',
                color: 'text.primary',
                display: {xs: 'none', sm: 'block'},
              }}>
              SmartMixin
            </Box>
          )}
        </Stack>

        {/* Navigation links - desktop only */}
        {!isMobile && (
          <Stack direction="row" spacing={0.5} sx={{ml: 3}}>
            <Button href={'/app/stations/'} color="inherit" size="small">
              {formatMessage(messages.stations.weatherStations)}
            </Button>
            <Button href={'/map/'} color="inherit" size="small">
              {formatMessage(messages.weatherMap.weatherMap)}
            </Button>
            {forecastMapsEnabled && <ForecastMapsMenu />}
            <Button href={'/help'} color="inherit" size="small">
              {formatMessage(messages.common.help)}
            </Button>
          </Stack>
        )}

        {/* Spacer */}
        <Box sx={{flexGrow: 1}} />

        {/* Right side actions */}
        <Stack direction="row" spacing={0.5}>
          <ThemeToggle />
          <UserMenu />
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default AppNavBar;
